<template>
    <div class="two">
        <div class="two-left">
            <button-create class="mb-5" variant="indigo" :label="$t('common.create_program')"
                :subtitle="$t('common.create_program_hint')" icon="mdi-plus" @click="goToCreateProgram" />

            <div class="mu">
                <most-used-carousel type="programs" customTitleStyle :coachId="coachId" />
            </div>

            <div class="sec-hd">
                <span class="sec-tit">{{ $t('common.your_folders') }}</span>
                <button type="button" class="sec-add" @click="showAdminFolders()">
                    <v-icon size="13">mdi-plus</v-icon>
                    {{ $t('common.folder') }}
                </button>
            </div>
            <div class="fg" v-if="currentFoldersType.length > 0">
                <folder-card v-for="folder in currentFolders" :key="folder.id" :folder="folder"
                    :is-active="isActiveFolder(folder)" @click="onSelectFolder(folder)"
                    @click:edit="showAdminFolders(folder)" />
            </div>
            <div v-else class="folders-empty">{{ $t('common.no_folders') }}</div>
            <kimsa-pagination v-if="pageCount > 1" class="mt-3" center @page="onChangePage($event)" :pageCount="pageCount"
                :total-visible="isMobile ? 5 : 7" :value="page + 1" />
        </div>

        <div class="rc">
            <div class="panel-srch">
                <kimsa-text-field class="srch-input" @change="setSearch" :value="search"
                    :placeholder="$t('common.search_name_tag')" prepend-inner-icon="mdi-magnify" dense />
                <button-tooltip :tooltip="$t('common.refresh')" top>
                    <template v-slot:activator="{ on, attrs }">
                        <button type="button" class="refresh-btn" @click="refresh" v-bind="attrs" v-on="on">
                            <v-icon size="16">mdi-refresh</v-icon>
                        </button>
                    </template>
                </button-tooltip>
            </div>
            <div class="rch">
                <span class="rct">{{ rightTitle }}</span>
            </div>
            <programs @loading="loading = $event" :search="search" :folder="folderId" :total-visible-pagination="5"
                ref="programs" :coach-id="coachId" />
        </div>

        <admin-folders-dialog ref="folders" type="programs" :coach-id="coachId" :folder="currentFolder"
            @hide="currentFolder = null" />

        <save-program-dialog ref="createProgram" from-scratch :coach-id="coachId" @success="onProgramCreated" />
    </div>
</template>

<script>
import FolderCard from '@/components/common/cards/FolderCard'
import KimsaPagination from '@/components/common/KimsaPagination'
import Programs from '@/components/coach/routines/Programs';
import AdminFoldersDialog from '@/components/coach/AdminFoldersDialog.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import MostUsedCarousel from '../MostUsedCarousel.vue';
import ButtonCreate from '../../common/inputs/ButtonCreate.vue';
import KimsaTextField from '../../common/inputs/KimsaTextField.vue';
import ButtonTooltip from '@/components/common/ButtonTooltip';
import SaveProgramDialog from './../routines/SaveProgramDialog.vue';

export default {
    components: { FolderCard, KimsaPagination, Programs, AdminFoldersDialog, MostUsedCarousel, ButtonCreate, KimsaTextField, ButtonTooltip, SaveProgramDialog },
    name: "ProgramsTab",
    data() {
        return {
            search: '',
            loading: false,
            folderId: null,
            currentFolder: null,
            page: 0,
        }
    },
    computed: {
        ...mapState(['folders', 'libraryFolder', 'libraryPage', 'libraryCoach']),
        currentFoldersType(vm = this) {
            return vm.folders.filter(folder => folder.type === 'programs') || []
        },
        currentFolders(vm = this) {
            let currentPage = (vm.page * 4)
            return vm.currentFoldersType.slice(currentPage, currentPage + 4)
        },
        coachId(vm = this) {
            if (vm.isCompany) return vm.libraryCoach?.id || null
            return vm.currentUser?.uid || null
        },
        pageCount(vm = this) {
            return Math.ceil(vm.currentFoldersType.length / 4)
        },
        rightTitle(vm = this) {
            if (vm.folderId) {
                const folder = vm.currentFoldersType.find(f => f.id === vm.folderId)
                if (folder) return vm.folderLabel(folder)
            }
            return vm.$t('common.programs')
        },
    },
    async mounted() {
        const vm = this;
        if (vm.folders.length === 0) await vm.bindFolders(vm.coachId)
        if (vm.libraryFolder) vm.folderId = vm.libraryFolder
        if (vm.libraryPage) vm.page = vm.libraryPage
    },
    methods: {
        ...mapMutations(['setLibraryFolder', 'setLibraryPage']),
        ...mapActions(['bindFolders']),
        onSelectFolder(folder) {
            const vm = this
            let folderId = folder?.id || null
            if (vm.folderId === folderId) folderId = null
            this.setLibraryFolder(folderId)
            vm.folderId = folderId
        },
        showAdminFolders(folder) {
            const vm = this
            if (folder) vm.currentFolder = folder
            vm.$refs.folders.show()
        },
        isActiveFolder(folder) {
            const vm = this
            return vm.folderId === folder.id
        },
        setSearch(search) {
            const vm = this;
            vm.search = search || ''
        },
        refresh() {
            const vm = this;
            if (vm.$refs.programs) vm.$refs.programs.refresh()
        },
        goToCreateProgram() {
            const vm = this;
            vm.$refs.createProgram.show()
        },
        onProgramCreated(id) {
            const vm = this;
            if (!id) return
            vm.pushRoute({ name: `${vm.accountType}.routines.program.detail`, params: { uid: id } })
        },
        onChangePage(page) {
            const vm = this;
            vm.setLibraryPage(page - 1)
            vm.page = page - 1
        },
    },
    watch: {
        loading(val) {
            this.$emit('loading', val)
        },
    },
}
</script>

<style scoped>
.two {
    display: grid;
    grid-template-columns: 1fr 360px;
    gap: 24px;
    align-items: start;
}

.two-left {
    min-width: 0;
}

.mu {
    margin-bottom: 20px;
}

.sec-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.sec-tit {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.sec-add {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 26px;
    padding: 0 10px;
    border-radius: 6px;
    border: 1px solid rgba(51, 153, 153, .3);
    background: none;
    color: var(--v-accent-base);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all .15s;
}

.sec-add:hover {
    background: rgba(51, 153, 153, .08);
}

.sec-add .v-icon {
    color: inherit !important;
}

.fg {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.folders-empty {
    text-align: center;
    font-size: 12px;
    color: var(--v-txtMuted-base);
    padding: 12px 0;
}

.rc {
    min-width: 0;
}

.panel-srch {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.srch-input {
    flex: 1;
}

.refresh-btn {
    width: 38px;
    height: 38px;
    min-width: 38px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--v-txtMuted-base);
    flex-shrink: 0;
    transition: all .15s;
}

.refresh-btn:hover {
    color: var(--v-txtSecondary-base);
    border-color: var(--v-outline2-base);
}

.refresh-btn .v-icon {
    color: inherit !important;
}

.rch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.rct {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

@media (max-width: 960px) {
    .two {
        grid-template-columns: 1fr;
    }
}
</style>
